module.exports = __webpack_public_path__ + "img/circle-6.dcc586da.svg";